export const dashboardCards = [
  {
    moduleKey: "liveDashboard",
    title: "Live Dashboard",
    description: "View real-time agent activity and inbound call tracking",
    href: "/live-dashboard",
  },
  {
    moduleKey: "dailyCallAssignment",
    title: "Daily Call Assignment",
    description: "Assign contacts daily for telecalling",
    href: "/telecalling/daily-assignment",
  },
  {
    moduleKey: "customerInfoSearch",
    title: "Customer Info Search",
    description: "Search and view customer loyalty info",
    href: "/pilinfo",
  },
  {
    moduleKey: "pilBatchFetch",
    title: "PIL Batch Fetch",
    description: "Fetch PIL info based on SQL configured in backend",
    href: "/pilinfo/batch-fetch",
  },
  {
    moduleKey: "eligibilityCheck",
    title: "Eligibility Check",
    description: "Assess customer eligibility",
    href: "/eligibility-check",
  },
  {
    moduleKey: "welcomeLetter",
    title: "Generate Welcome Letter",
    description: "Module for welcome letter generation",
    href: "/welcome-letter",
  },
  {
    moduleKey: "telecallingRecords",
    title: "Telecalling Records",
    description: "Update & review telecalling responses",
    href: "/telecalling-records",
  },
  {
    moduleKey: "inboundCallEntry",
    title: "Inbound Call Entry",
    description: "Enter details of Inbound call received",
    href: "/inbound",
  },
  {
    moduleKey: "crifBureauSearch",
    title: "CRIF Bureau Search",
    description: "For Bureau pull/search",
    href: "/crif",
  },
  {
    moduleKey: "userManagement",
    title: "User Management",
    description: "Admin module for user Management",
    href: "/user-management",
  },
];
